import { ComponentType } from "react"
import { With } from "../common/componentExtensions"

import Store from "./tipiInterventoStore"
import Actions from "./tipiInterventoActions"

export let withTipiIntervento = <TProps extends {}>(cmp: ComponentType<TProps>) => With(cmp, Store, () => Actions.getAll());